<!--
Author: TangChen
Date: 2018-11-06
Desc: 投资者信息补录，由index.js 配置引入
-->
<template>
    <div :class="'view-info-collection view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <inv-info />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import invInfo from "@/components/acctInfo/invInfo.vue";
export default {
    name: "InfoCollection",
    components: {
        invInfo
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    methods: {
    }
};
</script>
<style lang="scss">
/* 用户信息 */
.view-info-collection {
  padding-bottom: 30px;
}
</style>
